
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator'
import {getModule} from "vuex-module-decorators";
import {store, TradeInModule} from "@returns-centre/store";

@Component({
  components: {
  },
})
export default class AppLoadingOverlay extends Vue {
  @Prop()  visible!: boolean;

  tradeInModule = getModule(TradeInModule, store);

  get isApplicableForCheckoutRedirect(): boolean {
    if(!this.tradeInModule.trade_in) {
      return false;
    }

    return this.tradeInModule.tradeInItemsContainItemExchangeProduct(this.tradeInModule.trade_in)
        && this.tradeInModule.trade_in_step == 5;
  }

}
